import { CustomPlaceholder, GroupDetailsModal } from '@/components'
import { AppForms, Chat } from '@/config'
import { LayoutPanel, useChatProps } from '@/hooks'
import { Getstream } from '@/services'
import { appStatusStore } from '@/stores'
import { useChannelStateContext } from 'stream-chat-react'

export const ChatEmptyPlaceholder = () => {
  const { channel } = useChannelStateContext()
  const { isGroup, membersCount, groupOwner, previewCreatedAt, user } = useChatProps({ channel })
  const { isGroupOwner } = Getstream.Chat.useMyMembership(channel)

  async function handleExitGroup() {
    appStatusStore.set('loading')

    Chat.Services.leaveGroup({
      channelId: channel.id,
      member: user,
      onSuccess: async () => {
        Chat.Store.setChannel(null)
        await LayoutPanel.showLeftPanel()
      },
      onFinally: () => {
        appStatusStore.set('idle')
      },
    })
  }

  return (
    <CustomPlaceholder
      iconSize={46}
      iconName='message-chat-circle'
      title='This chat is empty'
      description={isGroup ? `Group created ${previewCreatedAt} by ${groupOwner?.name}` : 'Send a message to begin the conversation.'}
      subTitle={isGroup ? `${membersCount} member${membersCount === 1 ? '' : 's'}` : null}
      buttonProps={isGroup ? {
        debugName: 'ChatEmptyPlaceholder.Button',
        text: isGroupOwner ? 'Add members' : 'Exit group',
        icon: isGroupOwner ? 'plus' : 'arrow-right',
        style: ['pillSmall', isGroupOwner ? 'neutralSecondary' : 'negativeSecondary'],
        onPress: isGroupOwner ? () => {
          AppForms.chatGroup.resetValues()
          GroupDetailsModal.open({ channel, initialPage: 'add_members' })
        } : handleExitGroup,
      } : null}
    />
  )
}
